import { render, staticRenderFns } from "./BaseRealName.vue?vue&type=template&id=462add23&scoped=true"
import script from "./BaseRealName.vue?vue&type=script&lang=js"
export * from "./BaseRealName.vue?vue&type=script&lang=js"
import style0 from "./BaseRealName.vue?vue&type=style&index=0&id=462add23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462add23",
  null
  
)

export default component.exports